var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page_body", class: { "page-bondo": _vm.isInBondo } },
    [
      _c("div", { class: { "bondo-login__bg": _vm.isInBondo } }),
      _vm._v(" "),
      _c("div", { staticClass: "login-tab fc-clearfix" }, [
        _c(
          "div",
          {
            staticClass: "login-tab-item",
            class: { active: _vm.loginType === 0 },
            on: {
              click: function($event) {
                _vm.loginType = 0
                _vm.isPhoneLogin = false
                _vm.isEmailLogin = false
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "login-tab-title",
                class: { "bondo-login": _vm.isInBondo }
              },
              [_vm._v(_vm._s(_vm.$t("m.login")))]
            ),
            _vm._v(" "),
            _vm.isInBuzzCast ? _c("span", { staticClass: "line" }) : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.isInBuzzCast
          ? _c(
              "div",
              {
                staticClass: "login-tab-item",
                class: { active: _vm.loginType === 1 },
                on: {
                  click: function($event) {
                    _vm.loginType = 1
                  }
                }
              },
              [
                _c("div", { staticClass: "login-tab-title" }, [
                  _vm._v(_vm._s(_vm.$t("m.scan_login")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "line" })
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.loginType === 0
        ? _c(
            "div",
            [
              _vm.isPhoneLogin
                ? _c("login-phone", {
                    attrs: { thisLangcountry: _vm.thisLangcountry },
                    on: {
                      isEmailLogin: _vm.emailLogin,
                      isPhoneLogin: _vm.phoneLogin
                    }
                  })
                : _vm.isEmailLogin
                ? _c("login-email", {
                    attrs: { thisLangcountry: _vm.thisLangcountry },
                    on: {
                      isEmailLogin: _vm.emailLogin,
                      isPhoneLogin: _vm.phoneLogin
                    }
                  })
                : _c("login-sdk", {
                    attrs: { thisLangcountry: _vm.thisLangcountry },
                    on: {
                      isEmailLogin: _vm.emailLogin,
                      isPhoneLogin: _vm.phoneLogin
                    }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loginType === 1 && _vm.isInBuzzCast ? _c("login-scan") : _vm._e(),
      _vm._v(" "),
      _c(
        "van-overlay",
        {
          attrs: {
            "class-name": "fc_overlay",
            show: _vm.$root.selOneAccount.show,
            "z-index": "100"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "login_box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "login_header" }, [
                _c("div", { staticClass: "fc-flex-1 fc-text-center" }, [
                  _vm._v(_vm._s(_vm.$t("m.sel_one_account")))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "login_close",
                  attrs: {
                    src: require("../../assets/img/login_top_icon03.png")
                  },
                  on: {
                    click: function($event) {
                      _vm.$root.selOneAccount.show = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._l(_vm.$root.selOneAccount.accountList, function(
                    item,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: "list" + index,
                        staticClass: "sel_account_list",
                        on: {
                          click: function($event) {
                            return _vm.selAccount(index)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "fc-flex fc-flex-vcenter" }, [
                          _c("img", {
                            staticClass: "user_photo",
                            attrs: { src: item.logo }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.nickName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "id" }, [
                              _vm._v("ID:" + _vm._s(item.userId))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("van-icon", {
                          staticClass: "checked_class",
                          class: {
                            "fc-main-color": _vm.selAccountIndex == index
                          },
                          attrs: { name: "checked" }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fc-text-center fc-pad-sm" }, [
                    _vm.selAccountIndex || _vm.selAccountIndex == 0
                      ? _c(
                          "span",
                          {
                            staticClass: "confirm_sel_btn sel",
                            on: {
                              click: function($event) {
                                return _vm.selThisLogin()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("m.sureBtn")))]
                        )
                      : _c("span", { staticClass: "confirm_sel_btn" }, [
                          _vm._v(_vm._s(_vm.$t("m.sureBtn")))
                        ])
                  ])
                ],
                2
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a2af8af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2af8af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/Login.vue
// module id = null
// module chunks = 